export default "__VITE_ASSET__917a060a__"